export const buildCruisePageVisited = cruiseCode => ({
  type: "CruisePageVisited",
  cruiseCode
});
export const buildLastSeenProductDeleted = cruiseCode => ({
  type: "LastSeenProductDeleted",
  cruiseCode
});
export const buildBookingStarted = ({
  sessionId,
  cruiseCode,
  returnUrl
}) => ({
  type: "BookingStarted",
  sessionId,
  cruiseCode,
  returnUrl
});
export const buildBookingGuestsChanged = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  returnUrl
}) => ({
  type: "BookingGuestsChanged",
  sessionId,
  cruiseCode,
  adults,
  kids,
  returnUrl
});
export const buildBookingFareSelected = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl
}) => ({
  type: "BookingFareSelected",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl
});
export const buildBookingDeleted = () => ({
  type: "BookingDeleted"
});
export const buildBookingSuiteCategoryVisited = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl
}) => ({
  type: "BookingSuiteCategoryVisited",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl
});
export const buildBookingSuiteCategorySelected = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory
}) => ({
  type: "BookingSuiteCategorySelected",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory
});
export const buildBookingSuiteNumberSelected = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
}) => ({
  type: "BookingSuiteNumberSelected",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
});
export const buildBookingGuestInfoVisited = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
}) => ({
  type: "BookingGuestInfoVisited",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
});
export const buildBookingGuestInfoSubmitted = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
}) => ({
  type: "BookingGuestInfoSubmitted",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber
});
export const buildBookingCourtesyHoldCreated = ({
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber,
  bookingNumber,
  expirationDate
}) => ({
  type: "BookingCourtesyHoldCreated",
  sessionId,
  cruiseCode,
  adults,
  kids,
  fare,
  flights,
  returnUrl,
  suiteCategory,
  suiteNumber,
  bookingNumber,
  expirationDate
});
export const buildBookingCompleted = () => ({
  type: "BookingCompleted"
});
//# sourceMappingURL=UserEvents.js.map